import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react';
import { ReactInternetSpeedMeter } from 'react-internet-meter';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import InputAdornment from '@mui/material/InputAdornment';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CloseIcon from '@mui/icons-material/Close';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import apiFetch from '../utils/apiFetch';

import Timer from './Timer';
import './ScheduleInterviewUI.css';
import { UserContext } from './UserContext';

import { MenuItem, Select, Button, TextField, Autocomplete, InputLabel, FormControl, Modal, Box } from '@mui/material';
import InterviewApplicantPopup from './InterviewApplicantPopup';
import EmailTemplatesPopup from './EmailTemplatesPopup';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditJobs from './EditJobs';
import WorkPreferencesScheduleInterviewUI from './WorkPreferencesScheduleInterviewUI';

// Extracted Components
import JobSelection from './JobSelection';
import LanguagesTextbox from './LanguagesTextbox';
import InterviewAudioPopup from './InterviewAudioPopup';
import AudioRecorder from './AudioRecorder';
import InterviewResultForm from './InterviewResultForm';
import ReferralForm from './ReferralForm';

const NearbyLocations = {
  position: 'relative',
  margin: "auto",
  height: "auto",
  minWidth: 600,
  maxWidth: 600,
  scrollY: "auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',
};

const rounds = [
  { label: 'HR Screening' },
  { label: 'Verification' },
  { label: 'Client Round' },
];

const locations = [
  { label: 'Mobile Call' },
  { label: 'Video Call' },
  { label: 'Diamond District' },
  { label: 'Nagawara' },
  { label: 'Indiranagar' },
];

const ScheduleInterviewUI = ({
  open, close, openMsg, closeMsg, interview, interviewMsg,
  showAlert, refresh, handleCloseView, type
}) => {
  const { user } = useContext(UserContext);

  // Core IDs and References
  const [interviewId, setInterviewId] = useState("");
  const [applicantId, setApplicantId] = useState();
  const [jobId, setJobId] = useState();
  const [companyName, setCompanyName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [jobsDataProps, setJobsDataProps] = useState();

  // Applicant Data
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [mail, setMail] = useState("");
  const [city, setCity] = useState("");
  const [area, setArea] = useState("");
  const [education, setEducation] = useState("");
  const [language, setLanguage] = useState("");
  const [resumeUrl, setResumeUrl] = useState("");
  const [expYears, setExpYears] = useState(0);
  const [expMonth, setExpMonths] = useState(0);
  const [totalExperience, setTotalExperience] = useState(0);
  const [previousCurrent, setPreviousCurrent] = useState(0);
  const [expectedSalary, setExpectedSalary] = useState(0);
  const [noticePeriod, setNoticePeriod] = useState(0);

  // Interview Metadata
  const [round, setRound] = useState("");
  const [interViewerName, setInterViewerName] = useState("");
  const [hrName, setHRName] = useState("");
  const [timeDate, setTimeDate] = useState(new Date().toISOString().slice(0, 16));
  const [nextinterviewDate, setNextInterviewDate] = useState(new Date(new Date().getTime() + 330 * 60000).toISOString().slice(0, 16));
  const [interViewLocation, setInterViewLocation] = useState("Mobile Call");

  // Feedback & Status
  const [result, setResult] = useState("");
  const [roundResult, setRoundResult] = useState("");
  const [status, setStatus] = useState("");
  const [feedback, setFeedback] = useState("");
  const [prevfeedback, setPrevFeedback] = useState("");
  const [egr, setEgr] = useState("");
  const [cmr, setCmr] = useState("");
  const [bookMark, setBookMark] = useState(false);
  const [bookMarkCmts, setBookMarkCmts] = useState("");

  // UI & Network Toggles
  const [openScheduler, setOpenScheduler] = useState(false);
  const [openApplicant, setOpenApplicant] = useState(false);
  const [openEmailTemplate, setOpenEmailTemplate] = useState(false);
  const [openJDModel, setOpenJDModel] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [openNext, setOpenNext] = useState(true);
  const [whatsappStatus, setWhatsappStatus] = useState(true);
  const [sendEmail, setSendEmail] = useState(false);
  const [mobileStatus, setMobileStatus] = useState("");
  const [wifiSpeed, setWifiSpeed] = useState(0);

  // Audio Popup State
  const [audioPopupOpen, setAudioPopupOpen] = useState(false);

  // External Lookups
  const [candidateRounds, setCandidateRounds] = useState([]);
  const [hRNames, setHRNames] = useState([]);
  const [areasOfinterview, setAreasOfinterview] = useState([]);
  const [companyCoordinates, setCompanyCoordinates] = useState([]);

  // Preferences & Job Data
  const [candidatePreference, setCandidatePreference] = useState({});
  const [voiceProcess, setVoiceProcess] = useState(true);
  const [nonVoiceProcess, setNonVoiceProcess] = useState(true);
  const [workFromHome, setWorkFromHome] = useState(true);
  const [workFromOffice, setWorkFromOffice] = useState(true);
  const [partTime, setPartTime] = useState(true);
  const [fullTime, setFullTime] = useState(true);
  const [nightShift, setNightShift] = useState(true);
  const [dayShift, setDayShift] = useState(true);
  const [companyTransportDay, setCompanyTransportDay] = useState(true);
  const [companyTransportNight, setCompanyTransportNight] = useState(true);
  const [ownTransport, setOwnTransport] = useState(true);
  const [willingToRelocate, setWillingToRelocate] = useState(true);

  // User meta
  const [createdbyid, setCreatedbyId] = useState("");
  const [createdbyname, setCreatedbyName] = useState("");

  const intervalRef = useRef(null);

  // ==========================================
  // INACTIVITY TIMEOUT LOGIC (3 MINUTES)
  // ==========================================
  const inactivityTimerRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const [countdown, setCountdown] = useState(null);

  const closeStateRef = useRef({ openNext, open, openMsg, close, closeMsg, showAlert });
  useEffect(() => {
    closeStateRef.current = { openNext, open, openMsg, close, closeMsg, showAlert };
  }, [openNext, open, openMsg, close, closeMsg, showAlert]);

  const resetInactivityTimer = useCallback(() => {
    if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current);
    if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);

    setCountdown(null); // Reset the visual countdown on any interaction

    // 170 seconds before starting the 10-second warning countdown
    inactivityTimerRef.current = setTimeout(() => {
      setCountdown(10);
      countdownIntervalRef.current = setInterval(() => {
        setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }, 170000);
  }, []);

  // Handle actual closure when countdown hits 0
  useEffect(() => {
    if (countdown === 0) {
      clearInterval(countdownIntervalRef.current);
      const currentRef = closeStateRef.current;
      if (currentRef.open) {
        currentRef.close(currentRef.openNext);
      } else if (currentRef.openMsg) {
        currentRef.closeMsg();
      }
      setOpenScheduler(false);
      currentRef.showAlert("Modal closed automatically after 3 minutes of inactivity.", "info");
      setCountdown(null);
    }
  }, [countdown]);

  useEffect(() => {
    if (openScheduler) {
      resetInactivityTimer();

      const activityEvents = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
      activityEvents.forEach(event => document.addEventListener(event, resetInactivityTimer));

      return () => {
        if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current);
        if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
        activityEvents.forEach(event => document.removeEventListener(event, resetInactivityTimer));
      };
    } else {
      if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current);
      if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
    }
  }, [openScheduler, resetInactivityTimer]);
  // ==========================================

  const getValue = useCallback((val, fallback = "") => {
    return val === undefined || val === "undefined" || val === null ? fallback : val;
  }, []);

  const fetchData = useCallback(async (url, params = {}) => {
    try {
      const res = await apiFetch(url, params);
      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || "Request failed");
      }
      return await res.json();
    } catch (err) {
      showAlert('55 ' + String(err.message || err), "error");
      return null;
    }
  }, [showAlert]);

  const getUsers = useCallback(async () => {
    let apiURL = process.env.REACT_APP_API_URL + "/users/getusers";
    let apiParams = { method: "GET", headers: { authtoken: localStorage.getItem("loggedintoken") } };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => { if (repos.data) setHRNames(repos.data); else showAlert("90 " + (repos.message || repos), "error"); })
      .catch((err) => showAlert(('53 ' + err), "error"));
  }, [showAlert]);

  const getLocations = useCallback(async () => {
    let apiURL = process.env.REACT_APP_API_URL + "/locations/getlocations";
    let apiParams = { method: "GET", headers: { authtoken: localStorage.getItem("loggedintoken") } };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => { if (repos.data) setAreasOfinterview(repos.data); else showAlert("656 " + (repos.message || repos), "error"); })
      .catch((err) => showAlert(('111 ' + err), "error"));
  }, [showAlert]);

  useEffect(() => {
    getUsers();
    getLocations();
  }, [getUsers, getLocations]);

  // FIX: removed `props` from dependencies so parent re-renders don't trigger resets
  const changeRound = useCallback(async (intvwId) => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/getinterview/" + intvwId;
    let apiParams = { method: "GET", headers: { authtoken: localStorage.getItem("loggedintoken") } };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then(async (repos) => {
        if (repos.data) {
          setCompanyName(`${repos.data.jobId.companyname} - ${repos.data.jobId.officeName}`);
          setInterviewId(repos.data._id);
          setName(repos.data.name);
          console.log("repos.data.interviewername", repos.data.interviewername)
          setInterViewerName(repos.data.interviewername.trim() === "" ? user.name : repos.data.interviewername);

          if (repos.data.interviewdate && repos.data.interviewtime) {
            let time = parseInt(parseInt(repos.data.interviewtime.split(':')[0]) * 60 + parseInt(repos.data.interviewtime.split(':')[1]) + 330);
            let interviewDateTime = new Date(new Date(new Date(repos.data.interviewdate).toDateString()).setMinutes(time)).toISOString().slice(0, 16);
            setTimeDate(interviewDateTime);
          } else {
            setTimeDate(new Date((new Date()).setMinutes(((new Date()).getMinutes() + 330))).toISOString().slice(0, 16));
          }
          setRound(repos.data.rounds);
          setInterViewLocation(repos.data.location === "undefined" ? "" : repos.data.location);
          setFeedback("");
          setPrevFeedback(repos.data.feedback === "undefined" ? "" : repos.data.feedback);
          setBookMark(repos.data.bookmark ?? false);
          setBookMarkCmts(repos.data.bookmarkcomment === "undefined" ? "" : (repos.data.bookmarkcomment ?? ""));
          setResult(repos.data.status);
          setRoundResult(repos.data.status);
          setMobile(repos.data.mobile);
          setCmr(repos.data.communicationRating === "undefined" ? "" : parseInt(repos.data.communicationRating));
          setEgr(repos.data.englishRating === "undefined" ? "" : parseInt(repos.data.englishRating));
          setJobId(repos.data.jobId._id);
          setJobTitle(repos.data.jobtitle);
          setHRName(repos.data.hrname);

          if (repos.data.rounds === "Client Round") {
            setNextInterviewDate(new Date((new Date(new Date().toDateString())).setMinutes(930)).toISOString().slice(0, 16));
          } else if (Number(user.accesstype) >= 3) {
            setNextInterviewDate(new Date(new Date(new Date().toDateString()).setMinutes(2490)).toISOString().slice(0, 16));
          } else {
            setNextInterviewDate(new Date((new Date()).setMinutes(((new Date()).getMinutes() + 330))).toISOString().slice(0, 16));
          }
        } else showAlert("444 " + (repos.message || repos), "error");
      })
      .catch((err) => showAlert(('555 ' + err), "error"));
  }, [showAlert, user.name, user.accesstype]);

  // FIX: removed `props` from dependencies
  const getInterviewRounds = useCallback(async () => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/getscheduleinterview/" + applicantId + "/" + jobId;
    let apiParams = { method: "GET", headers: { authtoken: localStorage.getItem("loggedintoken") } };
    await apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setCandidateRounds(repos.data);
          if (repos.data.length > 0) { changeRound(repos.data[repos.data.length - 1]._id); }
        }
      })
      .catch((err) => showAlert(('666 ' + err), "error"));
  }, [applicantId, jobId, changeRound, showAlert]);

  useEffect(() => {
    if (applicantId) getInterviewRounds();
  }, [applicantId, getInterviewRounds]);

  const getMessagedInterview = useCallback(async (latestintwID) => {
    try {
      const apiURL = `${process.env.REACT_APP_API_URL}/interview/getlatestinterview/${latestintwID}`;
      const res = await apiFetch(apiURL, { method: "GET", headers: { authtoken: localStorage.getItem("loggedintoken") } });
      const data = res.status === 200 ? await res.json() : await res.text();

      if (!data.data) {
        showAlert("991 " + (data.message || data), "error");
        return;
      }

      const repo = data.data;
      setInterviewId(repo._id);
      setName(repo.name);
      setInterViewerName(repo.interviewername || user.name);
      setCompanyName(repo.companyname);

      if (repo.interviewdate && repo.interviewtime) {
        const [hours, minutes] = repo.interviewtime.split(':').map(Number);
        const interviewDate = new Date(repo.interviewdate);
        interviewDate.setHours(hours, minutes);
        setTimeDate(interviewDate.toISOString().slice(0, 16));
      } else {
        const now = new Date();
        now.setMinutes(now.getMinutes() + 330);
        setTimeDate(now.toISOString().slice(0, 16));
      }

      setRound(repo.rounds);
      setInterViewLocation(repo.location || "");
      setFeedback("");
      setPrevFeedback(repo.feedback || "");
      setBookMark(repo.bookmark ?? false);
      setBookMarkCmts(repo.bookmarkcomment || "");
      setResult(repo.status);
      setRoundResult(repo.status);
      setMobile(repo.mobile);
      setCmr(repo.communicationRating ? parseInt(repo.communicationRating) : "");
      setEgr(repo.englishRating ? parseInt(repo.englishRating) : "");
      setJobId(repo.jobId._id);
      setJobTitle(repo.jobId.jobtitle);
      setHRName(repo.hrname);

      let nextInterviewDate = new Date();
      if (repo.rounds === "Client Round") {
        nextInterviewDate.setHours(15, 30);
      } else if (Number(user.accesstype) >= 3) {
        nextInterviewDate.setHours(8, 30);
        nextInterviewDate.setDate(nextInterviewDate.getDate() + 1);
      } else {
        nextInterviewDate.setMinutes(nextInterviewDate.getMinutes() + 330);
      }
      setNextInterviewDate(nextInterviewDate.toISOString().slice(0, 16));

    } catch (err) {
      showAlert('433 ' + err, "error");
    }
  }, [showAlert, user.name, user.accesstype]);

  const preferencesMap = useMemo(() => ({
    voiceProcess: setVoiceProcess, nonVoiceProcess: setNonVoiceProcess, workFromHome: setWorkFromHome, workFromOffice: setWorkFromOffice,
    partTime: setPartTime, fullTime: setFullTime, nightShift: setNightShift, dayShift: setDayShift,
    companyTransportDay: setCompanyTransportDay, companyTransportNight: setCompanyTransportNight, ownTransport: setOwnTransport, willingToRelocate: setWillingToRelocate,
  }), []);

  const setPreference = useCallback((key, value) => {
    if (preferencesMap[key]) preferencesMap[key](value);
  }, [preferencesMap]);

  const getLanguages = useCallback(async () => {
    if (!interview?.applicantid) return;
    const url = `${process.env.REACT_APP_API_URL}/applicants/languages/${interview.applicantid}`;
    const res = await fetchData(url);

    if (!res?.data) {
      setLanguage(""); setPreviousCurrent(""); setExpectedSalary("");
      setCity(""); setArea(""); setEducation(""); setResumeUrl("");
      setExpYears(0); setExpMonths(0); setNoticePeriod(0);
      return;
    }

    const data = res.data;
    setLanguage(getValue(data.languages));
    setPreviousCurrent(getValue(data.currentSalary));
    setExpectedSalary(getValue(data.expectedSalary));
    setCity(getValue(data.city));
    setArea(getValue(data.area));
    setEducation(getValue(data.education));
    setResumeUrl(getValue(data.resumeUrl));
    setExpYears(Math.floor((data.experience || 0) / 12));
    setExpMonths((data.experience || 0) % 12);
    setNoticePeriod(getValue(data.noticePeriod, 0));

    const prefs = data.preferences ? JSON.parse(data.preferences) : {};
    Object.keys(preferencesMap).forEach(key => setPreference(key, prefs[key] ?? true));
  }, [interview?.applicantid, fetchData, getValue, preferencesMap, setPreference]);

  const timer = useCallback(async (action) => {
    if (!interview?.id) return;
    const url = `${process.env.REACT_APP_API_URL}/interview/timer/${interview.id}/${action}`;
    await fetchData(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", authtoken: localStorage.getItem("loggedintoken") },
    });
  }, [interview?.id, fetchData]);

  // FIX: This effect now ONLY runs once per interview ID, not on every object reference change
  useEffect(() => {
    if (!interview?.id) return;

    if (interviewId === interview.id) return;

    const populateInterview = async () => {
      setCompanyName(interview.companyname || "");

      setApplicantId(interview.applicantid);
      setJobId(interview.jobid);
      setInterviewId(interview.id);
      setCreatedbyId(interview.createdbyid);
      setCreatedbyName(interview.createdbyname);
      setName(interview.name || "");
      setInterViewerName(interview.interviewername || user.name);

      if (interview.interviewdate && interview.interviewtime) {
        try {
          const [hours, minutes] = interview.interviewtime.split(":").map(Number);
          const totalMinutes = hours * 60 + minutes + 330;
          const interviewDateTime = new Date(new Date(interview.interviewdate).setMinutes(totalMinutes))
            .toISOString().slice(0, 16);
          setTimeDate(interviewDateTime);
        } catch (error) {
          const defaultTime = new Date().setMinutes(new Date().getMinutes() + 330);
          setTimeDate(new Date(defaultTime).toISOString().slice(0, 16));
        }
      } else {
        const defaultTime = new Date().setMinutes(new Date().getMinutes() + 330);
        setTimeDate(new Date(defaultTime).toISOString().slice(0, 16));
      }

      setRound(interview.rounds);
      setInterViewLocation(interview.interviewlocation !== "undefined" ? interview.interviewlocation : "");
      setFeedback("");
      setPrevFeedback(interview.feedback !== "undefined" ? interview.feedback : "");
      setBookMark(interview.bookmark ?? false);
      setBookMarkCmts(interview.bookmarkcomment === "undefined" ? "" : (interview.bookmarkcomment ?? ""));

      setResult(interview.status);
      setRoundResult(interview.status);

      setMobile(interview.mobile);
      setMail(interview.mail);
      setJobTitle(interview.jobtitle);
      setCmr(interview.communicationrating !== "undefined" ? parseInt(interview.communicationrating) : "");
      setEgr(interview.englishrating !== "undefined" ? parseInt(interview.englishrating) : "");
      setHRName(interview.hrname);

      if (interview.rounds === "Client Round") {
        setNextInterviewDate(new Date(new Date().setHours(15, 30)).toISOString().slice(0, 16));
      } else if (Number(user.accesstype) >= 3) {
        setNextInterviewDate(new Date(new Date().setHours(41, 30)).toISOString().slice(0, 16));
      } else {
        setNextInterviewDate(new Date(new Date().setMinutes(new Date().getMinutes() + 330)).toISOString().slice(0, 16));
      }
    };
    populateInterview();
  }, [interview?.id, user.name, user.accesstype]);

  useEffect(() => {
    setOpenScheduler(open);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (open) {
      getLanguages();
      if (Number(user.accesstype) < 3 && interview?.id) {
        timer("start");
        intervalRef.current = setInterval(() => timer("active10"), 10000);
      }
    } else {
      timer("stop");
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [open, interview?.id, user.accesstype, getLanguages, timer]);

  useEffect(() => {
    if (!openMsg || !interviewMsg?._id) return;

    setOpenScheduler(openMsg);
    setApplicantId(interviewMsg._id);
    setRound(interviewMsg.latestinterviewround && interviewMsg.latestinterviewround !== "undefined" ? interviewMsg.latestinterviewround : "");
    setLanguage(interviewMsg.languages && interviewMsg.languages !== "undefined" ? interviewMsg.languages : "");
    setPreviousCurrent(interviewMsg.currentSalary && interviewMsg.currentSalary !== "undefined" ? interviewMsg.currentSalary : "");
    setExpectedSalary(interviewMsg.expectedSalary && interviewMsg.expectedSalary !== "undefined" ? interviewMsg.expectedSalary : "");
    setCity(interviewMsg.city && interviewMsg.city !== "undefined" ? interviewMsg.city : "");
    setArea(interviewMsg.area && interviewMsg.area !== "undefined" ? interviewMsg.area : "");
    setEducation(interviewMsg.education && interviewMsg.education !== "undefined" ? interviewMsg.education : "");
    setResumeUrl(interviewMsg.resumeUrl && interviewMsg.resumeUrl !== "undefined" ? interviewMsg.resumeUrl : "");
    setExpYears(interviewMsg.experience && interviewMsg.experience !== "undefined" ? Math.floor(interviewMsg.experience / 12) : 0);
    setExpMonths(interviewMsg.experience && interviewMsg.experience !== "undefined" ? interviewMsg.experience % 12 : 0);
    setNoticePeriod(interviewMsg.noticePeriod && interviewMsg.noticePeriod !== "undefined" ? interviewMsg.noticePeriod : 0);

    const prefs = interviewMsg.preferences ? JSON.parse(interviewMsg.preferences) : {};
    setVoiceProcess(prefs.voiceProcess ?? true);
    setNonVoiceProcess(prefs.nonVoiceProcess ?? true);
    setWorkFromHome(prefs.workFromHome ?? true);
    setWorkFromOffice(prefs.workFromOffice ?? true);
    setPartTime(prefs.partTime ?? true);
    setFullTime(prefs.fullTime ?? true);
    setNightShift(prefs.nightShift ?? true);
    setDayShift(prefs.dayShift ?? true);
    setCompanyTransportDay(prefs.companyTransportDay ?? true);
    setCompanyTransportNight(prefs.companyTransportNight ?? true);
    setOwnTransport(prefs.ownTransport ?? true);
    setWillingToRelocate(prefs.willingToRelocate ?? true);

    if (interviewMsg.latestinterviewid) {
      setInterviewId(interviewMsg.latestinterviewid);
      getMessagedInterview(interviewMsg.latestinterviewid);
    }
  }, [openMsg, interviewMsg?._id, getMessagedInterview, interviewMsg]);

  const handleClose = useCallback(() => {
    setCompanyName(null);
    setOpenLocationModal(false);
  }, []);

  const closeJDModel = useCallback(() => setOpenJDModel(false), []);

  const OpenLocationModal = useCallback((value) => {
    setOpenLocationModal(true);
    let apiURL = process.env.REACT_APP_API_URL + "/officelocations/getCompanyCoordinates/" + value.latitude + "/" + value.longitude;
    let apiParams = { method: "GET", headers: { authtoken: localStorage.getItem("loggedintoken") } };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) setCompanyCoordinates(repos.data);
        else showAlert("222 " + (repos.message || repos), "error");
      })
      .catch((err) => showAlert(('333 ' + err), "error"));
  }, [showAlert]);

  const nextRound = async () => {
    if (!applicantId) return showAlert("Applicant Id not found!", "error");

    const targetRound = Number(user.accesstype) >= 3 ? "Client Round" : "Verification";

    if (round === targetRound) {
      return showAlert(`Attempting to create duplicate ${targetRound}!`, "error");
    }

    if (!companyName || !companyName.includes(" - ")) return showAlert("Please select a valid Company and Office.", "error");
    if (!jobId) return showAlert("Vacancy not Selected!", "error");

    const apiURL = `${process.env.REACT_APP_API_URL}/interview/applyinterview/${applicantId}`;

    // 👇 FIX: Move all data into the headers object to match backend expectations
    const apiParams = {
      method: "POST",
      headers: {
        name: name,
        email: mail,
        mobile: mobile,
        jobid: jobId,
        jobtitle: jobTitle,
        hrname: hrName,
        feedback: encodeURIComponent(`${user.name} [${new Date().toLocaleString()}]:\n${feedback}\n${prevfeedback || ""}\n`),
        reference: interview?.reference || interviewMsg?.reference || "",
        interviewername: Number(user.accesstype) >= 3 ? "Client Interviewer" : "",
        round: targetRound,
        interviewdate: nextinterviewDate,
        interviewtime: nextinterviewDate.split('T')[1],
        location: Number(user.accesstype) >= 3 ? "" : "Mobile Call",
        createdbyid: user._id,
        createdbyname: user.name,
        authtoken: localStorage.getItem("loggedintoken")
      }
    };

    try {
      // 👇 FIX: Pass apiParams directly instead of stringifying a body
      await fetchData(apiURL, apiParams);

      if (whatsappStatus) WhatsappMsg();
      if (sendEmail) SendEmail();
      showAlert("Interview round created for applicant", "info");
    } catch (err) {
      showAlert("84 " + String(err), "error");
    }
  };

  const RetrieveResume = useCallback((data) => {
    let apiURL = process.env.REACT_APP_API_URL + "/applicants/saveResumeUrl/" + applicantId;
    let apiParams = { method: "POST", headers: { resumeurl: data.url, authtoken: localStorage.getItem("loggedintoken") } };
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => { if (repos.data) setResumeUrl(data.url); })
      .catch(e => console.log(e));
  }, [applicantId]);

  const handleUpload = async (e) => {
    var file = e.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      var rawLog = reader.result.split(',')[1];
      var dataSend = { dataReq: { data: rawLog, name: name[0].toUpperCase() + name.slice(1), type: file.type }, fname: "uploadFilesToGoogleDrive" };
      apiFetch(process.env.REACT_APP_GOOGLEDRIVE_URL, { method: "POST", body: JSON.stringify(dataSend) })
        .then(res => res.json()).then((data) => {
          RetrieveResume(data);
          showAlert("Resume Uploaded Successfully", "success");
        }).catch(e => console.log(e));
    }
  }

  const LoadSelectedJob = useCallback((job) => {
    setOpenApplicant(false);
    if (job) { setJobId(job); setOpenScheduler(true); getInterviewRounds(); }
    else { setOpenScheduler(false); close(openNext); }
  }, [getInterviewRounds, openNext, close]);

  const sendWhatsapp = useCallback(() => {
    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + mobile.trim().replace(' ', '').substring(mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Good Day " + name[0].toUpperCase() + name.slice(1) + ",%0a%0aI am trying to reach you for a job vacancy. " + mobileStatus + "%0a%0aKindly call me back if interested to apply.%0a%0aFollow us on LinkedIn by clicking https://www.linkedin.com/company/bizi-bees-outsourcing";
    window.open(apiURL, '_blank');
  }, [user.device, mobile, name, mobileStatus]);

  const WhatsappMsg = useCallback(() => {
    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + mobile.trim().replace(' ', '').substring(mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Congratulations " + name[0].toUpperCase() + name.slice(1) + ",%0a%0aYou have cleared the HR Screening round.%0a%0aPlease stay in touch for further updates.%0a%0aFollow us on LinkedIn by clicking https://www.linkedin.com/company/bizi-bees-outsourcing";
    window.open(apiURL, '_blank');
  }, [user.device, mobile, name]);

  const WhatsappRejectedCandidates = useCallback(() => {
    let apiURL = "https://" + (user.device === "mobile" ? "api" : "web") + ".whatsapp.com/send/?phone=+91" + mobile.trim().replace(' ', '').substring(mobile.trim().replace(' ', '').length - 10) + "&type=phone_number&app_absent=0&text=Dear " + name[0].toUpperCase() + name.slice(1) + ",%0a%0aIt was a pleasure talking to you!%0a%0aPlease stay updated on the latest vacancies by following us on our LinkedIn Page by clicking https://www.linkedin.com/company/bizi-bees-outsourcing";
    window.open(apiURL, '_blank');
  }, [user.device, mobile, name]);

  const SendEmail = useCallback(() => {
    setTotalExperience(parseInt(expYears * 12) + parseInt(expMonth));
    setOpenEmailTemplate(true);
  }, [expYears, expMonth]);

  const showApplicant = useCallback(() => {
    setOpenScheduler(false);
    setOpenApplicant(true);
  }, []);

  const joinedRound = async () => {
    if (!applicantId) return showAlert("Applicant Id not found!", "error");

    let apiURL = process.env.REACT_APP_API_URL + "/interview/applyinterview/" + applicantId;
    let apiParams = {
      method: "POST",
      headers: {
        name: name, email: mail, mobile: mobile,
        jobid: jobId, jobtitle: jobTitle, hrname: hrName,
        reference: interview?.reference || interviewMsg?.reference || "",
        feedback: encodeURIComponent(user.name + " [" + new Date().toLocaleString() + "]:\n" + feedback + "\n" + (prevfeedback || "") + "\n"),
        companyname: companyName && companyName.split(" - ")[0],
        interviewername: Number(user.accesstype) >= 3 ? "Client Interviewer" : "",
        round: "Joined", interviewdate: nextinterviewDate, interviewtime: nextinterviewDate.split('T')[1],
        location: "", status: "Joined", createdbyid: user._id, createdbyname: user.name,
        authtoken: localStorage.getItem("loggedintoken")
      },
    };
    try {
      const res = await apiFetch(apiURL, apiParams);
      const repos = res.status === 200 ? await res.json() : await res.text();
      if (repos.data) {
        setTimeout(() => { showAlert("Applicant has been Marked as Joined", "info") }, 2000);
      } else {
        showAlert((repos.message || repos || "already applied for this job"), "error");
      }
    } catch (err) {
      showAlert(('27 ' + err), "error");
    }
  };

  const accessRestricted = Number(user.accesstype) < 3;
  const isFinalStatus = status === "Selected" || status === "Joined" || status === "Joined & Left" || status === "Invoiced";
  const invalidCompany = !companyName || companyName === "" || companyName.split(" - ").length < 2 || !companyName.split(" - ")[0] || !companyName.split(" - ")[1];
  const restrictedRound = accessRestricted && (round === "Verification" || hrName !== user.name);
  const hideUpdate = (accessRestricted && isFinalStatus) || restrictedRound || invalidCompany || !jobId;

  const EditInterview = async () => {
    if (!companyName || companyName.split(" - ").length !== 2) return showAlert("Please select the Company for which Interviewed!", "error");
    if (!jobId || jobId.length < 2) return showAlert("Please select the Job for which Interviewed!", "error");
    if (result === "Next Round" && (!language || language.length < 2)) return showAlert("Please enter Candidate Languages!", "error");
    if (["Next Round", "Rejected", "Cancelled"].includes(result)) {
      if (!egr) {
        resetInactivityTimer();
        return showAlert("Select English Rating", "error");
      }
      if (!cmr) {
        resetInactivityTimer();
        return showAlert("Select Communication Rating", "error");
      }
    }
    if (!feedback || feedback.trim().length < 5) return showAlert("Enter your feedback!", "error");

    let bookMarkObj = "";
    let feedbackObj = "";
    const currentBookmarkComment = interview?.bookmarkcomment === "undefined" ? "" : (interview?.bookmarkcomment ?? "");
    const enteredBookmarkComment = bookMarkCmts === "undefined" ? "" : (bookMarkCmts ?? "");
    if (interview) {
      bookMarkObj = interview.bookmark !== bookMark ? enteredBookmarkComment : currentBookmarkComment;
      const bookmarkMessage = interview.bookmark !== bookMark ? bookMark ? `Bookmark added with comments: ${bookMarkObj}\n` : `Bookmark removed with comments: ${bookMarkObj}\n` : "";
      feedbackObj = encodeURIComponent(`${user.name} [${new Date().toLocaleString()}]:\n` + `${feedback}\n` + bookmarkMessage + `${prevfeedback || ""}\n`);
    }
    else {
      feedbackObj = encodeURIComponent(`${user.name} [${new Date().toLocaleString()}]:\n` + `${feedback}\n` + `${prevfeedback || ""}\n`);
    }

    const apiURL = `${process.env.REACT_APP_API_URL}/interview/editinterview/`;
    const apiParams = {
      method: "POST",
      headers: {
        applicantid: applicantId,
        interviewid: interviewId,
        interviewername: interViewerName, hrname: hrName, interviewdate: timeDate, interviewtime: timeDate.split("T")[1],
        rounds: round, location: encodeURIComponent(interViewLocation), companyname: companyName, jobid: jobId, jobtitle: jobTitle,
        createdbyid: user._id, createdbyname: user.name, feedback: feedbackObj, bookmark: Boolean(bookMark), bookmarkcomments: bookMarkObj ?? "", result: result,
        languages: language?.endsWith(",") ? language.slice(0, -1) : language, currentsalary: previousCurrent, expectedsalary: expectedSalary,
        preferences: JSON.stringify({ voiceProcess, nonVoiceProcess, workFromHome, workFromOffice, partTime, fullTime, nightShift, dayShift, companyTransportDay, companyTransportNight, ownTransport, willingToRelocate }),
        city, area, education, experience: parseInt(expYears) * 12 + parseInt(expMonth), noticeperiod: noticePeriod ? parseInt(noticePeriod) : 0,
        communicationrating: cmr, englishrating: egr, authtoken: localStorage.getItem("loggedintoken")
      }
    };

    try {
      const res = await apiFetch(apiURL, apiParams);
      const repos = res.status === 200 ? await res.json() : await res.text();

      if (repos.data) {
        if (result === "Next Round" && roundResult !== "Next Round") {
          await nextRound();
        } else if (result === "Joined" && round !== "Joined") {
          await joinedRound();
        } else if (whatsappStatus) {
          if (result === "Not Reachable") sendWhatsapp();
          else if (["Next Round", "Passed"].includes(result)) WhatsappMsg();
          else if (["Rejected", "Cancelled"].includes(result)) WhatsappRejectedCandidates();
        }

        showAlert("Interview Updated Successfully", "success");
      } else {
        showAlert(`${repos.message || repos}`, "error");
      }

      if (interview) {
        close(openNext);
      } else {
        closeMsg();
      }
      refresh();

    } catch (err) {
      showAlert('433 ' + String(err), "error");
    }
  };

  const areaLoc = useMemo(() => (areasOfinterview)?.map((loc) => loc.area) || [], [areasOfinterview]);
  const hrnames = useMemo(() => (hRNames)?.map((hr) => hr.name) || [], [hRNames]);
  const cols = useMemo(() => [
    { field: 'id', headerName: 'id', hide: true },
    { field: 'company', headerName: 'Company', width: 150, },
    { field: 'office', headerName: 'Office', width: 150 },
    { field: 'distance', headerName: 'Distance(km)', width: 150, headerAlign: 'center', align: "center" },
  ], []);

  const rowData = useMemo(() => (companyCoordinates || []).map((co) => {
    return { id: co._id, company: co.company, office: co.office, distance: parseInt(co.distance) };
  }), [companyCoordinates]);

  const isJobSelectionDisabled = Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening";
  const workPrefsObject = useMemo(() => ({ voiceProcess, nonVoiceProcess, fullTime, partTime, workFromOffice, workFromHome, dayShift, nightShift, companyTransportDay, companyTransportNight, ownTransport }), [voiceProcess, nonVoiceProcess, fullTime, partTime, workFromOffice, workFromHome, dayShift, nightShift, companyTransportDay, companyTransportNight, ownTransport]);
  const candidatePrefObject = useMemo(() => ({ candidatePreference }), [candidatePreference]);
  const emailTemplateApplicantObject = useMemo(() => ({ area, previousCurrent, expectedSalary, mobile, noticePeriod, totalExperience }), [area, previousCurrent, expectedSalary, mobile, noticePeriod, totalExperience]);

  const interviewFormState = {
    interViewerName, hrnames,
    isRestricted: Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening",
    result, round, roundResult,
    propsInterview: interview,
    feedback, prevfeedback, egr, cmr
  };

  const interviewFormActions = {
    setInterViewerName, setResult, setFeedback,
    setMobileStatus, setEgr, setCmr
  };

  return (
    <>
      <Modal open={openScheduler} onClose={handleCloseView} sx={{ overflow: 'scroll', textAlign: "center" }}>
        <div id="schedule_interviews_Modal">

          {/* 10 Second Countdown Overlay */}
          {countdown !== null && (
            <div style={{
              position: 'absolute',
              top: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: '#f44336',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              zIndex: 9999,
              fontWeight: 'bold',
              boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
              textAlign: 'center'
            }}>
              Closing in {countdown} seconds due to inactivity.<br />
              <span style={{ fontSize: '12px', fontWeight: 'normal' }}>Move your mouse or press a key to keep open.</span>
            </div>
          )}

          {Number(user?.accesstype) < 3 && <AudioRecorder interviewId={interviewId} userId={user?._id} />}

          <img id="popUpBackground1" src="n_291450.png" srcSet="n_291450.png 1x, n_291450@2x.png 2x" alt="background" />
          <img id="popUpBackground2" src="n_7973908.png" srcSet="n_7973908.png 1x, n_7973908@2x.png 2x" alt="background" />
          <div className="ScheduleInterviewBackground">
            <rect id="ScheduleInterviewBackground" rx="0" ry="0" x="0" y="0" width="539" height="100"></rect>
            <Timer style={{ width: "50px", height: "5%" }} class="ScheduleInterviewBackground" started={open} />
            <ReactInternetSpeedMeter
              txtSubHeading="Internet is too slow" outputType="empty" customClassName={null} txtMainHeading="Opps..."
              pingInterval={15000} thresholdUnit='megabyte' threshold={10} imageUrl="/bizibees.jpeg" downloadSize="18800"
              callbackFunctionOnNetworkDown={(speed) => `Internet speed is down ${speed}`}
              callbackFunctionOnNetworkTest={(speed) => setWifiSpeed(speed)}
            />
            <div style={{ zIndex: "10", position: "relative", color: wifiSpeed < 10 ? "red" : "white" }}>Internet speed: {wifiSpeed} mb/s</div>
          </div>
          <svg className="ScheduleTitle_PC">
            <linearGradient id="ScheduleTitle_PC" spreadMethod="pad" x1="0.436" x2="-0.378" y1="1" y2="-1.052">
              <stop offset="0" stopColor="#fff" stopOpacity="1"></stop>
              <stop offset="1" stopColor="#808080" stopOpacity="1"></stop>
            </linearGradient>
            <rect id="ScheduleTitle_PC" rx="17" ry="17" x="0" y="0" width="400" height="65"></rect>
          </svg>

          <div className='Schedule_CancelBtn'>
            <Button title="Close" id='Schedule_CancelBtn' size="small" variant="Standard" sx={{ bgcolor: "white", float: "right", right: 0, top: 0, position: "absolute", height: 28, width: 5 }} onClick={() => {
              if (open === true) { close(openNext); setOpenScheduler(false); }
              else if (openMsg === true) { closeMsg(); setOpenScheduler(false); }
            }}> <CloseIcon style={{ height: "25px", width: "25px" }} /> </Button>
          </div>

          <div id="Candidate_Username_"><span><marquee>{name}</marquee></span></div>
          <div id="Candidate_Mobile_"><span>{<a href={"tel:" + mobile}>{mobile}</a>}</span></div>

          {status === "Applied" && interview?.rounds === undefined ?
            <div className='Interview_Rounds_Hr'>
              <Autocomplete disablePortal id="txtRounds" freeSolo options={rounds} sx={{ width: 250 }} value={round || ""} onChange={(event, value) => setRound(value.label)}
                renderInput={(params) => <TextField {...params} size="small" label="Interview Round" value={round || ""} onChange={(e) => setRound(e.target.value)} />}
              />
            </div>
            :
            <div className='Hr_Rounds_1' style={{ textAlign: "center", fontFamily: 'Times New Roman' }}>{[...new Set(candidateRounds)].map(rnd => rnd._id === interviewId ? <b key={rnd._id}>{round}</b> : <input key={rnd._id} type="button" style={{ border: "1px solid", top: "231px", padding: "2px 6px", margin: "5px", borderRadius: "10px" }} onClick={() => { changeRound(rnd._id); }} value={rnd.rounds} />)}</div>
          }

          <div className='Interview_Hr_Names' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Autocomplete
              disablePortal
              id="Interview_Hr_Names"
              freeSolo
              options={hrnames}
              sx={{ width: 250 }}
              disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
              value={hrName || ""}
              onChange={(event, value) => setHRName(value)}
              renderInput={(params) =>
                <TextField
                  {...params}
                  InputProps={{ ...params.InputProps, startAdornment: <InputAdornment position="start"><AccountBoxIcon /></InputAdornment>, }}
                  sx={{ width: 250 }}
                  size="small"
                  label="HR Name"
                  disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"}
                  value={hrName || ""}
                  onChange={(e) => { setHRName(e.target.value); }}
                />}
            />
            {interviewId && (interview?.hasAudio || interviewMsg?.hasAudio) && (

              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ minWidth: '40px', height: '40px' }}
                onClick={() => setAudioPopupOpen(true)}
                title="View Audio Recordings"
              >
                <AudiotrackIcon />
              </Button>
            )}
          </div>

          <div className='Interview_Date_Time'>
            <small>{round !== "Joined" ? "Interview Date & Time: " : "Joined Date: "}</small><input type="datetime-local" style={{ width: "250px", height: "50%", backgroundColor: "transparent", border: "1px solid", padding: "2px 6px" }} max={new Date().toISOString().slice(0, 16)} value={timeDate} onChange={(e) => setTimeDate(e.target.value)} disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"} />
          </div>

          <JobSelection
            isDisabled={isJobSelectionDisabled}
            companyName={companyName}
            setCompanyName={setCompanyName}
            jobId={jobId}
            setJobId={setJobId}
            setCandidatePreference={setCandidatePreference}
            setJobTitle={setJobTitle}
            setJobsDataProps={setJobsDataProps}
            showAlert={showAlert}
            applicantName={name}
            applicantMobile={mobile}
            userDevice={user.device}
            userPhone={user.phone}
            onViewJob={() => setOpenJDModel(true)}
          >
            <div className='Resume_Upload_'>
              <FileUploadIcon style={{ marginLeft: "5px", color: "cornflowerblue" }} onClick={(e) => document.getElementById('candidateResume').click()} />
              <input id="candidateResume" type="file" placeholder="Upload Resume" style={{ display: "none" }} name="Resume" onChange={(e) => handleUpload(e)}></input>
              {resumeUrl && resumeUrl !== "" ? <FileDownloadIcon style={{ marginLeft: "5px", color: "cornflowerblue" }} onClick={(e) => document.getElementById('candidateResumeDownload').click()} /> : ""}
              {resumeUrl && resumeUrl !== "" ? <a id="candidateResumeDownload" style={{ display: "none" }} name="Resume" href={resumeUrl} target="_blank" rel="noreferrer" ></a> : ""}
            </div>
          </JobSelection>

          <div className='Interview_Locations'>
            <Autocomplete disablePortal id="Interview_Locations" freeSolo options={locations} sx={{ width: 250 }} disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"} value={interViewLocation || "Mobile Call"} onChange={(event, value) => setInterViewLocation(value.label)}
              renderInput={(params) => <TextField {...params} InputProps={{ ...params.InputProps, startAdornment: <InputAdornment position="start"> <LocationOnIcon /></InputAdornment>, }} sx={{ minWidth: 250 }} size="small" label={round !== "Joined" ? "Interview Location" : "Joined Location"} disabled={Number(user.accesstype) < 3 && (roundResult === "Next Round" || roundResult === "Passed") && round === "HR Screening"} multiline value={interViewLocation || ""} onChange={(e) => { setInterViewLocation(e.target.value); }} />}
            />
          </div>

          <div className='Interviews_Candidate_City'>
            <TextField InputProps={{ startAdornment: <InputAdornment position="start"><LocationCityIcon /></InputAdornment>, }} sx={{ width: 250 }} id="Interviews_Candidate_City" size="small" label="City" variant="outlined" value={city} onChange={(e) => { setCity(e.target.value); }} />
            <br />
            {(areasOfinterview || []).filter(rec => (rec.area || "").toLowerCase().trim() === (area || "").toLowerCase().trim()).length > 0 ?
              <div><a href="#" onClick={() => OpenLocationModal((areasOfinterview || []).filter(rec => (rec.area || "").toLowerCase().trim() === (area || "").toLowerCase().trim())[0])}>Show Office Distances</a></div> : ""}
          </div>

          <div className='Candidate_Area'>
            <Autocomplete disablePortal id="Candidate_Area" freeSolo options={areaLoc} sx={{ width: 250 }} value={area || ""} onChange={(event, value) => { setArea(value); }}
              renderInput={(params) => <TextField {...params} sx={{ width: 250 }} size="small" label="Area" value={area || ""} onChange={(e) => { setArea(e.target.value); }} />}
            />
          </div>

          <div className='Candidate_Education'>
            <TextField sx={{ width: "300px", marginTop: "2px", }} id="Candidate_Education" size="small" label="Education" variant="outlined" value={education} onChange={(e) => { setEducation(e.target.value) }} />
          </div>

          <LanguagesTextbox language={language} setLanguage={setLanguage} />

          <WorkPreferencesScheduleInterviewUI type={type} preferences={workPrefsObject} highlight={candidatePrefObject} setPreference={(key, value) => setPreference(key, value)} />

          <div className='Willing_to_Relocate_Preference'>
            <input type="checkbox" id="Willing_to_Relocate_Preference" name="Willing_to_Relocate_Preference" checked={willingToRelocate} onChange={() => setWillingToRelocate(!willingToRelocate)} />
          </div>
          <label id='Willing_to_Relocate_lbl_' htmlFor="Willing_to_Relocate_Preference" style={{ color: willingToRelocate ? "red" : "black" }}>Willing To Relocate</label>

          <ReferralForm
            jobId={jobId}
            jobTitle={jobTitle}
            companyName={companyName}
            hrName={hrName}
            round={round}
            showAlert={showAlert}
          />

          {Number(user.accesstype) < 3 && (status === "Selected" || status === "Joined" || status === "Joined & Left" || status === "Invoiced") ? <div className='Applied_lbl' style={{ textAlign: "center", color: "cornflowerblue", fontWeight: "bold" }}><h4>{status}</h4></div> :
            <InterviewResultForm
              formState={interviewFormState}
              formActions={interviewFormActions}
            />
          }

          {(result === "Next Round" ||
            result === "Scheduled" ||
            (result === "Joined" && interview?.status !== "Joined")) && (
              <div id="Next_Round_On_lbl">
                <span>
                  {result === "Next Round"
                    ? "Next Round On: "
                    : result === "Scheduled"
                      ? "Re-scheduled To: "
                      : result === "Joined" && interview?.status !== "Joined"
                        ? "Joined Date: "
                        : ""}
                </span>
              </div>
            )}

          <div className="NextInterviewDateTime">
            {(result === "Next Round" ||
              result === "Scheduled" ||
              (result === "Joined" && interview?.status !== "Joined")) && (
                <input
                  type="datetime-local"
                  id="NextInterviewDateTime"
                  style={{
                    width: "180px",
                    height: "35px",
                    backgroundColor: "transparent",
                    border: "1px solid",
                    padding: "2px 6px",
                  }}
                  disabled={
                    (roundResult === "Next Round" || roundResult === "Passed") &&
                    round === "HR Screening"
                  }
                  value={nextinterviewDate}
                  onChange={(e) => setNextInterviewDate(e.target.value)}
                />
              )}
          </div>

          <div className='Bookmark_Chck'><input type="checkbox" id="Bookmark_Chck" name="bookmark" checked={bookMark} onChange={() => setBookMark(!bookMark)} /></div>
          <div id="Bookmark_lbl"><span>Bookmark</span></div>

          <div className='Schedule_Bookmarkcmts'>
            <input type="text" style={{ width: "175px", height: "50px", border: "1px solid", padding: "2px 6px" }} id="Schedule_Bookmarkcmts" name="bookmarkComments" placeholder="Bookmark Comments" disabled={(!interview && !bookMark) || (!interview?.bookmark && !bookMark) || interview?.bookmark === bookMark} value={bookMarkCmts} onChange={(e) => setBookMarkCmts(e.target.value)} />
          </div>

          <div className='Open_Next_txt'><input type="checkbox" id="Open_Next_txt" name="chkOpenNext" checked={openNext} onChange={() => setOpenNext(!openNext)} /></div>
          <div id="Open_Next_lbl"><span>Open Next</span></div>

          {(result === 'Not Reachable' || result === 'Next Round' || result === 'Rejected' || result === 'Cancelled') ? <div className='WhatsApp_Status_Chck'><input type="checkbox" id="WhatsApp_Status_Chck" name="chkWhatsapp" checked={whatsappStatus} onChange={() => setWhatsappStatus(!whatsappStatus)} /></div> : ""}
          {(result === 'Not Reachable' || result === 'Next Round' || result === 'Rejected' || result === 'Cancelled') ? <div id="WhatsApp_Status_lbl"><span>WhatsApp Status</span></div> : ""}

          <div className='Send_Email_txt'>
            {companyName && companyName.split(" - ")[0] === "Focus Edumatics" ? <input type="button" id="Send_Email_txt" name="chkEmail" style={{ border: "1px solid", padding: "2px 6px" }} value="Send Email" onClick={() => { setSendEmail(!sendEmail); SendEmail() }} /> : ""}
          </div>

          <div className="Update_btn_1">
            {hideUpdate ? null : (<Button type="button" title="Update" disabled={!result} variant="contained" onClick={EditInterview}>Update</Button>)}
          </div>

          <svg className="ScheduleInterviewPointer1"><ellipse id="ScheduleInterviewPointer1" rx="7" ry="7" cx="7" cy="7"></ellipse></svg>
          <svg className="ScheduleInterviewProgress1" viewBox="0 0 234 1"><path id="ScheduleInterviewProgress1" d="M 0 0 L 234 0"></path></svg>
          <svg className="ScheduleInterviewApplicantPointer"><ellipse onClick={() => showApplicant()} id="ScheduleInterviewApplicantPointer" rx="7" ry="7" cx="7" cy="7"></ellipse></svg>
          <svg className="SchedulePath_1" viewBox="18.881 193.052 389.968 2677.099"><path id="SchedulePath_1" d="M 85.56208801269531 193.6184234619141 L 87.39723968505859 193.6184234619141 L 103.7058486938477 225.7629699707031 L 408.8490905761719 225.7629699707031 L 408.8490905761719 2870.150390625 L 213.97705078125 2870.150390625 L 19.56823921203613 2870.150390625 L 18.88072967529297 226.8946838378906 L 71.920654296875 225.7629699707031 L 86.46845245361328 193.0517578125"></path></svg>

          <img id="ScheduleInterviewcalendar1" src="calendar1.png" srcSet="calendar1.png 1x, calendar1@2x.png 2x" alt="calendar" />
          <img onClick={() => showApplicant()} id="ScheduleInterviewuserPage" src="user4.png" srcSet="user4.png 1x, user4@2x.png 2x" alt="user" />
        </div>
      </Modal>

      <InterviewAudioPopup
        open={audioPopupOpen}
        onClose={() => setAudioPopupOpen(false)}
        interviewId={interviewId}
        intervieweeName={interview?.name}
        hrName={interview?.hrname}
        showAlert={showAlert}
      />

      <Modal open={openLocationModal} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={NearbyLocations}>
          <div>
            <h4 className="fnt2"><b>NearBy Locations</b>
              <Button title="Close" size="small" variant="Standard" sx={{ bgcolor: "red", float: "right", right: 0, top: 0, position: "absolute", height: 28, width: 5 }} onClick={() => handleClose()} > <CloseIcon style={{ height: "25px", width: "25px" }} /> </Button>
            </h4>
          </div>
          <div style={{ height: 750, width: '100%', margin: "0px" }}>
            <DataGrid initialState={{ sorting: { sortModel: [{ field: 'distance', sort: 'asc' }], }, }} rows={rowData} columns={cols} components={{ Toolbar: GridToolbar, }} />
          </div>
        </Box>
      </Modal>

      <InterviewApplicantPopup open={openApplicant} highlight={candidatePrefObject} showAlert={showAlert} applicantId={applicantId} close={job => { setJobId(job); if (jobId === job) { LoadSelectedJob(jobId) } }} />
      <EditJobs type={"View"} openJobs={openJDModel} jobsData={jobsDataProps} showAlert={showAlert} close={closeJDModel} />
      <EmailTemplatesPopup jobTitle={jobTitle} toEmail={mail} open={openEmailTemplate} showAlert={showAlert} applicantId={applicantId} applicantName={name} applicant={emailTemplateApplicantObject} close={() => setOpenEmailTemplate(false)} />
    </>
  )
}

export default ScheduleInterviewUI;